import { datadogRum } from '@datadog/browser-rum'
import type { Router } from 'vue-router'

interface RUMLocation {
  id: string
  name: string
}

interface RUM {
  identify(location: RUMLocation): void
  setRouter(router: Router): void
  addError(error: unknown): void
}

class DatadogRUM implements RUM {
  constructor() {
    if (!import.meta.env.VITE_DATADOG_CLIENT_TOKEN) return
    datadogRum.init({
      applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
      clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
      site: 'datadoghq.eu',
      proxy: 'https://datadog.last.app',
      service: 'bookings',
      env: 'prod',
      version: '2.0.0',
      allowedTracingUrls: [import.meta.env.VITE_API_BASE_URL],
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: false,
      trackViewsManually: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowFallbackToLocalStorage: true,
      beforeSend: event => {
        if (event.type === 'error' && event.error.type === 'NetworkError') {
          return false
        }
        return true
      }
    })
  }

  identify(location: RUMLocation) {
    datadogRum.setUser({
      id: location.id,
      name: location.name
    })
  }

  setRouter(router: Router) {
    router.afterEach(to => {
      datadogRum.startView({ name: to.name?.toString() })
    })
  }

  addError(error: unknown) {
    datadogRum.addError(error)
  }
}

const rum: RUM = new DatadogRUM()

export default rum
